<app-kontable
        #table
        id="dt_usd"
        title = "{{ 'common.userStoreDivisionSection' | translate }}"
        [columns]="[
        {field: 'id',  title: 'common.id'},
        {field: 'store_name', title: 'common.store_name',  bodyTemplate: storeTemplate},
        {field: 'division_name', title: 'salesNetworkList.saleNetwork', bodyTemplate: salesNetworkTemplate},
        {field: 'username', title: 'common.usernameNewUsd', sortable:false },
        {field: 'login', title: 'userForm.login', sortable:false },
        { field: 'scope', title: 'Scope', filterType: selectFilter, filterOptions: {values: scope}, bodyTemplate: scopeTemplate}
        ]"
        [titles] = "['common.id', 'common.store_name', 'common.username']"
        [showInfoButton]="false"
        [showRecoverButton]="true"
        [showGlobalFilter]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        [paginationType]="paginationType"
        [service]="userStoreDivisionService"
        (onAdd)="showAddOrEditDialog($event)"
        (onEdit)="showAddOrEditDialog($event)"
        (onRecover)="recover($event)"
        (onRemove)="delete($event)">

        <ng-template #storeTemplate data-testid="storeTemplate" let-row>
                <span>{{ row.store_host_code }} - {{ row.store_name }}</span>
        </ng-template>

        <ng-template  #salesNetworkTemplate data-testid="salesNetworkTemplate" let-row>
          <span *ngIf="row.store_name === null">{{ row.division_name }} - {{ row.sales_network_name }}</span>
          <span *ngIf="row.store_name != null"> - </span>
        </ng-template>

        <ng-template #scopeTemplate data-testid="scopeTemplate" let-row>
                <ng-container *ngIf="notSpecTitle">
                  <span *ngIf="row.scope === 'null' || row.scope === null; else showScope">{{notSpecTitle}}</span>
                  <ng-template #showScope>
                    <span>{{row.scope}}</span>
                  </ng-template>
                </ng-container>
              </ng-template>

</app-kontable>

<p-dialog *ngIf="showDetail"
          [width]="600"
          [(visible)]="showDetail"
          header="{{modalTitle}}"
          [responsive]="true"
          showEffect="fade"
          [modal]="true"
          (onHide)="onDialogHide()">

  <app-user-store-division-form
          [editingElement]="svc.editing_user_store_division"
          (onUpdateElement)="onUpdateElement($event)"
          (onAddElement)="onAddElement($event)">
  </app-user-store-division-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/user-store-division/user-store-division.component.html